import React from "react";
import PropTypes from "prop-types";
import { LANGUAGES, useI18n } from "../i18n/LanguageContext";

const LABELS = { kk: "ҚАЗ", ru: "РУС", en: "ENG" };

function LanguageSwitch({ tone = "bar" }) {
  const { language, setLanguage, t } = useI18n();
  const activeClass =
    tone === "light" ? "bg-pink-600 text-white" : "bg-white text-pink-600";
  const idleClass =
    tone === "light"
      ? "bg-lime-100 text-gray-800 hover:bg-lime-200"
      : "bg-lime-500 text-black hover:bg-lime-300";

  return (
    <div
      className={`inline-flex overflow-hidden rounded-lg border ${
        tone === "light" ? "border-gray-200" : "border-white/40"
      }`}
      role="group"
      aria-label={t("lang.label")}
    >
      {LANGUAGES.map((code) => {
        const active = language === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLanguage(code)}
            aria-pressed={active}
            className={`btn-smooth px-2 py-1 text-xs font-bold sm:px-3 sm:text-sm ${
              active ? activeClass : idleClass
            }`}
          >
            {LABELS[code]}
          </button>
        );
      })}
    </div>
  );
}

LanguageSwitch.propTypes = {
  tone: PropTypes.oneOf(["bar", "light"]),
};

export default LanguageSwitch;
